import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { XyzPoint } from 'cd-eft/models/SurveyEngineering/XyzPoint';
import stores from 'cd-eft/models/Stores';
import { calcRotationAngle } from '../Maps/SETMapFunctions/translationComposite';
import { PointTranslationRotationVM } from './PointTranslationRotationVM';
import { SelectPointOnMapButton } from '../PointTranslationSelectPointButton';

const setStore = stores.AppStore.surveyEngineeringStore;

// third Option
export const TranslationRotation = observer((props) => {
  const vm = useRef(new PointTranslationRotationVM(props)).current;

  setStore.pivotDeltaX = setStore.pivotTargetX - setStore.pivotRefX;
  setStore.pivotDeltaY = setStore.pivotTargetY - setStore.pivotRefY;
  setStore.pivotDeltaZ = setStore.pivotTargetZ - setStore.pivotRefZ;

  const [rotateAngle, registrationError] = calcRotationAngle(
    new XyzPoint(setStore.pivotRefX, setStore.pivotRefY, 0),
    new XyzPoint(setStore.pivotTargetX, setStore.pivotTargetY, 0),
    new XyzPoint(setStore.angleRefX, setStore.angleRefY, 0),
    new XyzPoint(setStore.angleTargetX, setStore.angleTargetY, 0)
  );
  setStore.rotationAngle = rotateAngle;
  setStore.registrationError = registrationError;

  return (
    <div className="translation-option-3">
      <div className="point-translation-header">
        <h5>Translate/Rotate all points in XY and/or Z by identifying matching points</h5>
      </div>
      <div className="translate-region">
        <div>
          <h5>Translate</h5>
        </div>
        <div className="form-row-fixed-height">
          <div className="col col-md-3 display-flex">
            <label className="usa-label">Ref. Pt </label>
            <input
              disabled
              type="text"
              className="usa-input"
              id="ref-pt"
              value={setStore.pivotRefName}
              onChange={vm.onChangeHandler}
            />
            <SelectPointOnMapButton pointType="pivotRef" setFormError={props.setFormError} />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;X </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="ref-pt-x"
              value={setStore.pivotRefX}
              name="pivotRefX"
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Y </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="ref-pt-y"
              value={setStore.pivotRefY}
              name="pivotRefY"
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Z </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="ref-pt-z"
              value={setStore.pivotRefZ}
              name="pivotRefZ"
            />
          </div>
        </div>
        <div className="form-row-fixed-height">
          <div className="col col-md-3 display-flex">
            <label className="usa-label">Target Pt</label>
            <input
              disabled
              type="text"
              className="usa-input"
              id="target-pt"
              value={setStore.pivotTargetName}
              name="pivotTargetName"
              onChange={vm.onChangeHandler}
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;X </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="target-pt-x"
              value={setStore.pivotTargetX}
              name="pivotTargetX"
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Y </label>
            <input disabled type="number" className="usa-input" id="target-pt-y" value={setStore.pivotTargetY} />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Z </label>
            <input disabled type="number" className="usa-input" id="target-pt-z" value={setStore.pivotTargetZ} />
          </div>
        </div>
      </div>
      <div className="rotate-region">
        <div>
          <h5>Rotate</h5>
        </div>
        <div className="form-row-fixed-height">
          <div className="col col-md-3 display-flex">
            <label className="usa-label">Ref. Pt </label>
            <input
              disabled
              type="text"
              className="usa-input"
              id="ref-pt"
              value={setStore.angleRefName}
              onChange={vm.onChangeHandler}
            />
            <SelectPointOnMapButton pointType="angleRef" setFormError={props.setFormError} />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;X </label>
            <input disabled type="number" className="usa-input" id="ref-pt-x" value={setStore.angleRefX} />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Y </label>
            <input disabled type="number" className="usa-input" id="ref-pt-y" value={setStore.angleRefY} />
          </div>
        </div>
        <div className="form-row-fixed-height">
          <div className="col col-md-3 display-flex">
            <label className="usa-label">Target Pt</label>
            <input
              disabled
              type="text"
              className="usa-input"
              id="target-pt"
              value={setStore.angleTargetName}
              onChange={vm.onChangeHandler}
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;X </label>
            <input disabled type="number" className="usa-input" id="target-pt-x" value={setStore.angleTargetX} />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&nbsp;&nbsp;Y </label>
            <input disabled type="number" className="usa-input" id="target-pt-y" value={setStore.angleTargetY} />
          </div>
        </div>
      </div>
      <div className="results-region">
        <div>
          <h5>Results</h5>
        </div>
        <div className="form-row-fixed-height justify-content-center">
          <div className="col-md-3 py-2 text-right">Translate Values:</div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&Delta;X </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="results-delta-x"
              placeholder="0.00"
              value={setStore.pivotDeltaX.toFixed(3)}
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&Delta;Y </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="results-delta-y"
              placeholder="0.00"
              value={setStore.pivotDeltaY.toFixed(3)}
            />
          </div>
          <div className="col col-md-3 display-flex">
            <label className="usa-label">&Delta;Z </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="results-delta-z"
              placeholder="0.00"
              value={setStore.pivotDeltaZ.toFixed(3)}
            />
          </div>
        </div>
        <div className="form-row-fixed-height justify-content-center">
          <div className="col-md-3 py-2 text-right">Rotate Values:</div>
          <div className="col col-md-4 display-flex">
            <label className="usa-label">Angle </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="results-angle"
              placeholder="0.00"
              value={setStore.rotationAngle.toFixed(3)}
            />
          </div>
          <div className="col col-md-5 display-flex">
            <label className="usa-label">Registration error </label>
            <input
              disabled
              type="number"
              className="usa-input"
              id="results-registration-error"
              placeholder="0.00"
              value={registrationError.toFixed(3)}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
